import { MfaErrorType } from "../enums/mfa-error-type.enum";

/** RYNO-14957: the responses that refuse an authentication attempt without evaluating it. */
export const AuthThrottleErrorTypes: readonly MfaErrorType[] = [
  MfaErrorType.TooManyAttempts,
  MfaErrorType.AccountLocked,
  MfaErrorType.TooManyRequests,
];

/** True for an error code that AuthThrottleService.handle has already reported to the user. */
export const isAuthThrottleError = (errorCode?: string): boolean =>
  (AuthThrottleErrorTypes as readonly string[]).includes(errorCode);

const count = (value: number, unit: string): string =>
  `${value} ${unit}${value === 1 ? "" : "s"}`;

/** The portal wording of the story (Design C); the mobile app reuses it verbatim. */
export const AuthThrottleMessages = {
  tooManyAttempts: "Too many incorrect codes. Sign in again to receive a new code.",
  accountLocked: (retryAfterSeconds?: number): string =>
    retryAfterSeconds > 0
      ? `Too many failed attempts. Try again in ${count(Math.ceil(retryAfterSeconds / 60), "minute")}.`
      : "Too many failed attempts. Try again later.",
  tooManyRequests: (retryAfterSeconds?: number): string =>
    retryAfterSeconds > 0
      ? `Too many requests. Try again in ${count(Math.ceil(retryAfterSeconds), "second")}.`
      : "Too many requests. Try again later.",
};
